import avatar1 from "../assets/profile/avatar-1.jpg";
import avatar2 from "../assets/profile/avatar-2.jpg";
import avatar3 from "../assets/profile/avatar-3.jpg";
import avatar4 from "../assets/profile/avatar-4.jpg";
import avatar5 from "../assets/profile/avatar-5.jpg";
import avatar6 from "../assets/profile/avatar-6.jpg";
import avatar7 from "../assets/profile/avatar-7.jpg";
import avatar8 from "../assets/profile/avatar-8.jpg";
import avatar9 from "../assets/profile/avatar-9.jpg";
import avatar10 from "../assets/profile/avatar-10.jpg";

export const mockDataMesageValue = [
  {
    id: 1,
    name: "Jon Snow",
    to: "Ali Connors",
    message: "— I'll be in your neighborhood doing errands this…",
    avatar: avatar2,
  },
  {
    id: 2,
    name: "Anya Stark",
    to: "to Scott, Alex, Jennifer",
    message: "— Wish I could come, but I'm out of town this…",
    avatar: avatar1,
  },
  {
    id: 3,
    name: "Daenerys Targaryen",
    to: "Sandra Adams",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar3,
  },
  {
    id: 4,
    name: "Jaime Lannister",
    to: "Sandra Adams",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar4,
  },
  {
    id: 5,
    name: "Cersei Lannister",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar5,
  },
  {
    id: 6,
    name: "Ferrara Clifford",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar6,
  },
  {
    id: 7,
    name: "Ever Melisandre",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar7,
  },
  {
    id: 8,
    name: "Harvey Roxie",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar8,
  },
  {
    id: 9,
    name: "Rossini Frances",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar9,
  },
  {
    id: 10,
    name: "Harvey Roxie",
    to: "to Scott, Alex, Jennifer",
    message: "— Do you have Paris recommendations? Have you ever…",
    avatar: avatar10,
  },
];
